import gql from 'graphql-tag';

export default gql`
  fragment OrderPaymentFragment on OrderPayment {
    paymentType
    paymentStatus
    paymentMethod
    total {
      amount
      currency
    }
  }
`;
